import { pipe, identity } from '../Function/dist/effect-Function.esm.js';
import { tap, interruptible, interruptFiber, flatMap, context, map, provideContext, exit, exitSucceed } from './core.esm.js';
import { acquireRelease, forkDaemon } from './fiberRuntime.esm.js';
import { schedule_Effect } from './schedule.esm.js';
import { fromAcquire, get as get$1, set } from './scopedRef.esm.js';

/** @internal */
const ResourceSymbolKey = "effect/Resource";

/** @internal */
const ResourceTypeId = /*#__PURE__*/Symbol.for(ResourceSymbolKey);

/** @internal */
const cachedVariance = {
  _E: _ => _,
  _A: _ => _
};

/** @internal */
const auto = (acquire, policy) => tap(manual(acquire), manual => acquireRelease(pipe(refresh(manual), schedule_Effect(policy), interruptible, forkDaemon), interruptFiber));

/** @internal */
const manual = acquire => flatMap(context(), env => pipe(fromAcquire(exit(acquire)), map(ref => ({
  [ResourceTypeId]: cachedVariance,
  scopedRef: ref,
  acquire: () => provideContext(acquire, env)
}))));

/** @internal */
const get = self => flatMap(get$1(self.scopedRef), identity);

/** @internal */
const refresh = self => set(self.scopedRef, map(self.acquire(), exitSucceed));

export { ResourceTypeId, auto, get, manual, refresh };
